import { useTheme } from "@emotion/react"
import { Theme as MuiTheme } from "@mui/material/styles"

import { L2RTextField } from "../TextField"

import * as Styled from "./AutoCompleteWithChips.styled"

const BOX_MAX_HEIGHT = 114

interface AutoCompleteWithChipsProps {
    color?: "primary" | "secondary" | "tertiary" | "action/darkRed"
    getOptionLabel?: (_option: string) => string
    label?: string
    id?: string
    maxHeight?: number
    maxLength?: number
    options: Array<string>
    variant?: "filled" | "outlined"
}

export const AutoCompleteWithChips = (props: AutoCompleteWithChipsProps) => {

    const {
        color = "primary",
        label,
        id,
        maxHeight,
        maxLength,
        options,
        variant = "filled",
        ...autocompleteProps
    } = props

    const theme = useTheme() as MuiTheme

    const boxMaxHeight = maxHeight ?? BOX_MAX_HEIGHT

    return <Styled.AutoComplete
        {...autocompleteProps}
        color={color}
        multiple
        id={id}
        options={options}
        renderInput={(params) => {
            const { InputProps, ...restParams } = params
            const { startAdornment, ...restInputProps } = InputProps
            return <L2RTextField
                {...restParams}
                {...params}
                slotProps={{
                    input: {
                        ...restInputProps,
                        ...(startAdornment && {
                            startAdornment: (
                                <Styled.ChipsContainer maxHeight={boxMaxHeight}>
                                    {startAdornment}
                                </Styled.ChipsContainer>
                            )
                        }),
                    },
                    htmlInput: {
                        ...params.inputProps,
                        maxLength: maxLength,
                    },
                }}
                label={label}
            />
        }}
        slotProps={{
            paper: {
                sx: {
                    boxShadow: theme.customShadow("LCS/Shadow-dropdown"),
                    borderRadius: theme.spacing(3),
                    marginTop: theme.spacing(1),
                },
            },
            chip: {
                color: color,
                variant: variant,
            },
        }}
    />
}
